import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import ReactMarkdown from "react-markdown";
import MessageModal from '../container/MessageModal';
import MostrarPostutacion from '../container/MostrarPostutacion';
import { errorClassification } from '../errorHandler';

import ofertasServices from '../services/ofertasServices';
import resourcesServices from '../services/resourcesServices';

const OfertaVeedores = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false);
  const [saving, setSaving] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  const [oferta, setOferta] = useState({});
  const [veedores, setVeedores] = useState([]);
  const [veedoresAsociadosIds, setVeedoresAsociadosIds] = useState([]);
  let { id } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin')){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  useEffect(() => {
    fetchOferta(id)
    fetchVeedores()
  }, [id]);

  const fetchOferta = async (id) => {
    try {
      const data = await ofertasServices.obtenerOfertaPorId(id);
      setOferta(data);
      setVeedoresAsociadosIds(data.usuarios_veedore_ids)
      // setVeedoresAsociadosIds([39])

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const fetchVeedores = async () => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios/obtenerVeedores', '', '', '', ``);
      setVeedores(data.data);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const guardarVeedores = async () => {
    try {
      setSaving(true)

      const data = await resourcesServices.actualizarResource('ofertas', oferta.id, {oferta: {usuarios_veedore_ids: veedoresAsociadosIds}});
      setVeedoresAsociadosIds(data.usuarios_veedore_ids)

      handleShowModal("Datos actualizados");
      setSaving(false)
    } catch (error) {
      setSaving(false)
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const convertToTitleCase = (str) => {
    if(str){
      return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    }
  }

  const handleChecked = (e) => {
    const { name, value, checked } = e.target;

    const checked_value = parseInt(value);

    if(veedoresAsociadosIds.includes(checked_value)){
      setVeedoresAsociadosIds(veedoresAsociadosIds.filter(item => item !== checked_value));
    } else {
      setVeedoresAsociadosIds([...veedoresAsociadosIds, checked_value])
    }
  }

  return (
    <>
      {
        oferta && oferta.titulo && (
          <div className="px-4 py-2">
            <h3 className="text-center text-secondary">{convertToTitleCase(oferta.tipos)}</h3>
            <h1 className="display-5 fw-bold text-center text-body-emphasis">{oferta.titulo} <span className="badge bg-secondary">{oferta.cargo && oferta.cargo.nombre}</span></h1>

            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Email</th>
                  <th scope="col">Seleccionado?</th>
                </tr>
              </thead>
              <tbody>
                {
                  veedores.map((veedor) => (
                    <tr key={veedor.id}>
                      <td>{veedor.nombre} {veedor.apellido}</td>
                      <td>{veedor.email}</td>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            value={`${veedor.id}`}
                            name={`usuarios_veedore_ids[]`}
                            type="checkbox"
                            onChange={(e) => handleChecked(e)}
                            checked={veedoresAsociadosIds.includes(parseInt(veedor.id))}
                            role="switch" />
                        </div>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            {/* <pre>{JSON.stringify(veedoresAsociadosIds, null, 2)}</pre> */}
            <div>
              <button disabled={saving} className="btn btn-primary w-100 py-2" onClick={guardarVeedores} type="submit">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Guardar</span>
              </button>
            </div>


          </div>
        )
      }
     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default OfertaVeedores;